import React from "react";
import intl from "react-intl-universal";
import { Button, Box, Typography } from "@material-ui/core";
import { useHistory, Link } from "react-router-dom";
import { useGet } from "restful-react";
import ManageIcon from "@material-ui/icons/Group";
import moment from "moment-timezone";
import AssessmentIcon from "@material-ui/icons/Assessment";

import { routing } from "routing";
import { Heading } from "components/Heading";
import { Breadcrumbs } from "components/Breadcrumbs";
import { getDefaultTeam, getYearBoundaryInUtc } from "utils";
import { getTeam } from "apis";

import { AnnualMatch } from "./AnnualMatch";
import { AnnualPlayerRanking } from "./AnnualPlayerRanking";

const { Urls } = routing;

export const Overview = () => {
  const history = useHistory();
  const breadcrumbs = [
    {
      label: intl.get("TEAM_DASHBOARD"),
    },
  ];
  const teamId = getDefaultTeam();
  const year = moment().year();
  const range = getYearBoundaryInUtc(year.toString());

  const { data: queryTeamResponse } = useGet({
    path: getTeam(teamId),
  });

  if (
    !queryTeamResponse ||
    !queryTeamResponse.teams ||
    queryTeamResponse.teams.length === 0
  ) {
    return null;
  }

  const team = queryTeamResponse.teams[0];

  const navToTeamManagePage = () => {
    history.push(Urls.TEAM_MANAGEMENT());
  };

  const handleViewClick = () => {
    history.push(Urls.TEAM_STATS(teamId));
  };

  return (
    <>
      <Breadcrumbs breadcrumbs={breadcrumbs} />
      <Heading
        title={intl.get("TEAM_DASHBOARD_CURRENT_TEAM")}
        rightAction={
          <Button
            variant="contained"
            color="secondary"
            onClick={navToTeamManagePage}
            startIcon={<ManageIcon />}
          >
            {intl.get("TEAM_DASHBOARD_NAV_MANAGE")}
          </Button>
        }
      />
      <Box mt={2} />
      <Typography variant="h2">{team.name}</Typography>
      <Box mt={2} />
      <Typography variant="h4">{team.description}</Typography>
      <Box mt={2} />
      <Typography variant="h4">{team.address}</Typography>
      <Box mt={2} />
      <Link color="inherit" to={Urls.TEAM_EDIT(team.id)}>
        <Typography variant="h4">
          {intl.get("TEAM_DASHBOARD_PLAYERS", { playerNum: team.users.length })}
        </Typography>
      </Link>
      <Box mt={4} />
      <Heading title={intl.get("TEAM_DASHBOARD_ANNUAL_DATA")} />
      <AnnualMatch teamId={teamId} startTime={range.from} endTime={range.to} />
      <Box mt={4} />
      <Heading
        title={intl.get("TEAM_DASHBOARD_ANNUAL_PLAYER_RANKING")}
        rightAction={
          <Button
            variant="contained"
            color="secondary"
            startIcon={<AssessmentIcon />}
            onClick={handleViewClick}
          >
            {intl.get("TEAM_DASHBOARD_ANNUAL_PLAYER_DETAIL_DATA")}
          </Button>
        }
      />
      <AnnualPlayerRanking
        teamId={teamId}
        startTime={range.from}
        endTime={range.to}
      />
    </>
  );
};
